// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1lSx5","first-fold":"first-fold__1kI4g","conv-chart-container":"conv-chart-container__23y2N","bg-firstFold":"bg-firstFold__UHUYT","animatedPinchy":"animatedPinchy__MF53Z","bounce":"bounce__A32yL","h1Fontsize":"h1Fontsize__2o6EM"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/currency.scss
// module id = 1150
// module chunks = 68